import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const GetAssignableProviderChecklistDocs = (apiData) => async () => {
  try {
    const response = await axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/admin/provider/GetAssignableProviderChecklistDocs`,
      params: apiData,
    });
    return response.data;
  } catch (error) {
    return error?.response?.data || { success: false, message: error.message };
  }
};
